import React, { useContext } from 'react';
import Select from '../UI/Select';
import classes from './index.module.scss';
import { SearchContext } from '../../context/Search';

const SearchSettings = () => {
  const { totalCount, limit, offset, setLimit, setOffset } = useContext(SearchContext);

  const setLimitHandler = (event) => {
    setOffset(offset - (offset % event.value));
    setLimit(event.value);
  }

  return (
    <div className={classes.Search_Settings_Wrap}>
      <h6 className={classes.Total_Count}>Showing <b>{limit} of {totalCount}</b> entries</h6>
      <div className={classes.Search_Settings_Select_Wrap}>
        <div className={classes.Search_Settings_Select}>
          <h5 className={classes.Search_Settings_Select_Label}>
            Showing
          </h5>
          <Select
            name="limit"
            isSearchable={false}
            defaultValue={{value: limit, label: `${limit} per page`}}
            isClear={false}
            list={[
              { value: 5, label: "5 per page" }, 
              { value: 10, label: "10 per page" }, 
              { value: 20, label: "20 per page" }, 
              { value: 30, label: "30 per page" }, 
              { value: 40, label: "40 per page" },
              { value: 50, label: "50 per page" },
              { value: 100, label: "100 per page" },
              { value: 150, label: "150 per page" },
              { value: 200, label: "200 per page" }
            ]}
            handleMultiChange={setLimitHandler}
            styles="per-page-container"
            prefixStyles="per-page-select"
          />
        </div>
      </div>
    </div>
  )
}

export default SearchSettings;